<template>
  <div class="content background1">
    <div class="pageTitle"><p>角色管理</p></div>
    <div class="chooseBoxMin">
      <div class="chooseBox">
        <div class="selectBox">
          <div>
            <div class="selectChoose">
              <div class="selectText"><p>角色名称</p></div>
              <div class="select">
                <el-input v-model="searchDataList.roleName" placeholder="请输入角色名称"></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="buttonBox">
          <!--          <div>-->
          <!--            <div class="chooseButton exportButton" @click="model"><i class="el-icon-download"></i>导出</div>-->
          <!--          </div>-->
          <div>
            <div class="chooseButton sendButton" @click="search"><i class="el-icon-search"></i>查询</div>
          </div>
        </div>
      </div>
    </div>
    <div class="tableBox">
      <div class="tableMes">
        <div class="table">
          <div class="btnBox2">
            <div class="addButton" @click="insert"><i class="el-icon-circle-plus"></i>{{ $t('btn_14') }}</div>
            <div class="editButton" @click="update"><i class="el-icon-edit"></i>{{ $t('btn_15') }}</div>
            <div class="delButton" @click="del"><i class="el-icon-delete-solid"></i>{{ $t('btn_16') }}</div>
          </div>
          <el-table
            :data="tableData"
            highlight-current-row
            @current-change="handleCurrentChange"
            border
            style="width: 100%;"
            :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
            <el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex" width="50">
            </el-table-column>
            <el-table-column
              prop="roleName"
              label="角色名称" align="center">
            </el-table-column>
            <el-table-column
              prop="remark"
              label="角色描述" align="center">
            </el-table-column>
          </el-table>
        </div>
        <div style="position: absolute;bottom: 0;left: 30%">
          <Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
                @parentMethod="searchPage"></Page>
        </div>
      </div>

    </div>

    <el-dialog
      v-loading="saveLoading"
      :title=$t('btn_14')
      :visible.sync="unInsertVisible" append-to-body
      width="50%"
      :close-on-click-modal='false'
      top="10%"
      :before-close="handleClose" custom-class="dialogBox">
      <div style="width: 100%; margin: 0 auto;">
        <div class="dialogMes">
          <p>角色名称</p>
          <div class="mesInput">
            <el-input v-model="roleList.roleName"></el-input>
          </div>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <p>角色描述</p>
          <div class="mesInput">
            <el-input v-model="roleList.remarks"></el-input>
          </div>
        </div>
        <el-checkbox-group v-model="MenuDataList" style="width: 100%">
          <el-tabs type="border-card" style="height: 350px">
            <template v-for="(itemMenu,index) in MenuList">
              <el-tab-pane v-if="MenuRoleList.indexOf(itemMenu.menu)>=0">
	              <span slot="label">
	              <el-checkbox :label="itemMenu.menu" :key="itemMenu.menu"
                             @change="firstPermChanged(index)">&nbsp;</el-checkbox>{{ itemMenu.menuName }}
                </span>
                <div style="margin-left: 20px">
                  <template v-for="(itemSubmenu,index2) in itemMenu.subclass"
                            v-if="MenuRoleList.indexOf(itemSubmenu.menu)>=0">
                    <el-checkbox :label="itemSubmenu.menu" :key="itemSubmenu.menu"
                                 @change="secondPermChanged(index,index2)">{{ itemSubmenu.menuName }}
                    </el-checkbox>
                    <div style="margin-left: 20px">
                      <template v-for="(itemBtn,index3) in itemSubmenu.subclass"
                                v-if="MenuRoleList.indexOf(itemBtn.menu)>=0">
                        <el-checkbox :label="itemBtn.menu" :key="itemBtn.menu"
                                     @change="thirdPermChanged(index,index2,index3)">{{ itemBtn.menuName }}
                        </el-checkbox>
                      </template>
                    </div>
                  </template>
                </div>
              </el-tab-pane>
            </template>
          </el-tabs>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="chooseButton sendButton" @click="unInsertSend"><i class="el-icon-s-promotion"></i>{{ $t('btn_13') }}</div>
	  </span>
    </el-dialog>

    <el-dialog
      v-loading="saveLoading"
      :title=$t('btn_15')
      :visible.sync="unUpdateVisible" append-to-body
      width="50%"
      :close-on-click-modal='false'
      top="10%"
      :before-close="handleClose" custom-class="dialogBox">
      <div style="width: 100%; margin: 0 auto;">
        <div class="dialogMes">
          <p>角色名称</p>
          <div class="mesInput">
            <el-input v-model="roleList.roleName"></el-input>
          </div>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <p>角色描述</p>
          <div class="mesInput">
            <el-input v-model="roleList.remarks"></el-input>
          </div>
        </div>
        <el-checkbox-group v-model="MenuDataList" style="width: 100%">
          <el-tabs type="border-card" style="height: 350px">
            <template v-for="(itemMenu,index) in MenuList">
              <el-tab-pane v-if="MenuRoleList.indexOf(itemMenu.menu)>=0">
	              <span slot="label">
	              <el-checkbox :label="itemMenu.menu" :key="itemMenu.menu"
                             @change="firstPermChanged(index)">&nbsp;</el-checkbox>{{ itemMenu.menuName }}
                </span>
                <div style="margin-left: 20px">
                  <template v-for="(itemSubmenu,index2) in itemMenu.subclass"
                            v-if="MenuRoleList.indexOf(itemSubmenu.menu)>=0">
                    <el-checkbox :label="itemSubmenu.menu" :key="itemSubmenu.menu"
                                 @change="secondPermChanged(index,index2)">{{ itemSubmenu.menuName }}
                    </el-checkbox>
                    <div style="margin-left: 20px">
                      <template v-for="(itemBtn,index3) in itemSubmenu.subclass"
                                v-if="MenuRoleList.indexOf(itemBtn.menu)>=0">
                        <el-checkbox :label="itemBtn.menu" :key="itemBtn.menu"
                                     @change="thirdPermChanged(index,index2,index3)">{{ itemBtn.menuName }}
                        </el-checkbox>
                      </template>
                    </div>
                  </template>
                </div>
              </el-tab-pane>
            </template>
          </el-tabs>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
	    <div class="chooseButton sendButton" @click="unUpdateSend"><i
        class="el-icon-s-promotion"></i>{{ $t('btn_13') }}</div>
	  </span>
    </el-dialog>

    <el-dialog
      :title=$t('btn_16')
      :visible.sync="unDeleteVisible" append-to-body
      width="30%"
      top="10%"
      center
      :close-on-click-modal='false'
      :before-close="handleClose" custom-class="dialogBox">
      <p style="text-align: center;font-size: 16px">是否删除</p>
      <div class="btnBox2" style="width: 100%;justify-content: center;">
        <div class="editButton" @click="unDeleteVisible = false" style="">取 消</div>
        <div class="delButton" @click="unDeleteSend"><i class="el-icon-delete-solid"></i>删 除</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "@/assets/css/map/map.css"
import Page from "@/components/common/page";
import Role from "@/assets/js/role/role.js";
import store from '@/store'

import utils from '@/utils/utils'

export default {
  name: 'rolePage',
  components: {
    Page
  },
  data() {
    return {
      saveLoading: false,
      model: [],
      unDetailList: [],
      pageNum: 1,
      inputValue: 0,
      pageSize: 10,
      pageCount: 0,
      tableInfo: {},
      unInsertVisible: false,
      unUpdateVisible: false,
      unDeleteVisible: false,
      MenuDataList: [],
      MenuList: [
        {
          menu: 'A100',
          menuName: '主页',
        },
        {
          menu: 'A200',
          menuName: '设备实绩',
          subclass: [{
            menu: 'A210',
            menuName: '设备总览',
          }, {
            menu: 'A220',
            menuName: '日报表',
            subclass: [
              {
                menu: 'A221',
                menuName: '导出',
              }]
          }, {
            menu: 'A230',
            menuName: '月报表',
            subclass: [
              {
                menu: 'A231',
                menuName: '导出',
              }]
          }, {
            menu: 'A240',
            menuName: '报警记录',
          }],
        },
        {
          menu: 'A300',
          menuName: '系统设定',
          subclass: [{
            menu: 'A310',
            menuName: '设备管理',
            subclass: [
              {
                menu: 'A312',
                menuName: '查看',
              }, {
                menu: 'A311',
                menuName: this.$t('btn_15'),
              }]
          }, {
            menu: 'A320',
            menuName: '时间管理',
            subclass: [
              {
                menu: 'A324',
                menuName: '查看',
              }, {
                menu: 'A321',
                menuName: this.$t('btn_14'),
              }, {
                menu: 'A322',
                menuName: this.$t('btn_15'),
              }, {
                menu: 'A323',
                menuName: this.$t('btn_16'),
              }]
          }, {
            menu: 'A330',
            menuName: '用户管理',
            subclass: [
              {
                menu: 'A334',
                menuName: '查看',
              }, {
                menu: 'A331',
                menuName: this.$t('btn_14'),
              }, {
                menu: 'A332',
                menuName: this.$t('btn_15'),
              }, {
                menu: 'A333',
                menuName: this.$t('btn_16'),
              }, {
                menu: 'A335',
                menuName: '重置密码',
              }]
          }, {
            menu: 'A340',
            menuName: '角色管理',
            subclass: [
              {
                menu: 'A344',
                menuName: '查看',
              }, {
                menu: 'A341',
                menuName: this.$t('btn_14'),
              }, {
                menu: 'A342',
                menuName: this.$t('btn_15'),
              }, {
                menu: 'A343',
                menuName: this.$t('btn_16'),
              }]
          }],
        }],
      stationList: [{
        label: this.$t('label_272'),
        value: '0'
      }],
      searchDataList: {
        roleName: ''
      },
      searchList: [],
      MenuRoleList: [],
      roleList: {
        id: '',
        roleId: '',
        roleName: '',
        remarks: '',
        menu: []
      },
      tableData: []
    }
  },
  methods: {
    handler() {

    },
    insert() {
      this.unInsertVisible = true;
      this.roleList = {
        id: '',
        roleId: '',
        roleName: '',
        remarks: '',
        menu: []
      },
        this.MenuDataList = []
    },
    update() {
      if (Object.keys(this.tableInfo).length > 0) {
        this.MenuDataList = []
        var menuList = this.tableInfo.menu.split(",");
        for (var i = 0; i < menuList.length; i++) {
          this.MenuDataList.push(menuList[i]);
        }
        this.roleList.id = this.tableInfo.id;
        this.roleList.roleName = this.tableInfo.roleName;
        this.unUpdateVisible = true;
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    getIndex(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    // detailPop() {
    //   this.unDetailVisible = true
    // },
    find: function (id) {
      var isCheckAll = false;
      for (var i = 0; i < this.MenuDataList.length; i++) {
        if (this.MenuDataList[i] == id) {
          isCheckAll = true;
        }
      }
      return isCheckAll;
    },
    // 删除数组中的元素
    removeByValue: function (arr, val) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] == val) {
          arr.splice(i, 1);
          break;
        }
      }
    },
    // 点击一级权限
    firstPermChanged: function (index) {
      var firstPerm = this.MenuList[index];
      var isCheck = this.find(firstPerm.menu);
      // 一级权限是否选中
      if (isCheck) {
        if (firstPerm.subclass != "" && firstPerm.subclass != undefined) {
          for (var j = 0; j < firstPerm.subclass.length; j++) {
            // 添加所有的二级权限
            this.MenuDataList.push(firstPerm.subclass[j].menu);
            if (firstPerm.subclass[j].subclass != "" && firstPerm.subclass[j].subclass != undefined) {
              for (var k = 0; k < firstPerm.subclass[j].subclass.length; k++) {
                // 添加所有的三级权限
                this.MenuDataList.push(firstPerm.subclass[j].subclass[k].menu);
              }
            }
          }
        }
      } else {
        if (firstPerm.subclass != "" && firstPerm.subclass != undefined) {
          for (var j = 0; j < firstPerm.subclass.length; j++) {
            // 删除所有二级权限
            this.removeByValue(this.MenuDataList, firstPerm.subclass[j].menu);
            if (firstPerm.subclass[j].subclass != "" && firstPerm.subclass[j].subclass != undefined) {
              for (var k = 0; k < firstPerm.subclass[j].subclass.length; k++) {
                // 删除所有三级权限
                this.removeByValue(this.MenuDataList, firstPerm.subclass[j].subclass[k].menu);
              }
            }
          }
        }
      }
    },
    // 点击二级权限
    secondPermChanged: function (index, index2) {
      var firstPerm = this.MenuList[index];
      var secondPerm = this.MenuList[index].subclass[index2];
      var isSecondCheck = this.find(secondPerm.menu);   // 二级权限是否选中
      if (isSecondCheck) {
        // 添加一级权限
        if (!this.find(firstPerm.menu)) {
          this.MenuDataList.push(firstPerm.menu);
        }
        if (secondPerm.subclass != "" && secondPerm.subclass != undefined) {
          for (var j = 0; j < secondPerm.subclass.length; j++) {
            // 添加二级权限的三级权限
            this.MenuDataList.push(secondPerm.subclass[j].menu);
          }
        }
      } else {
        // 删除二级权限的三级权限
        if (secondPerm.subclass != "" && secondPerm.subclass != undefined) {
          for (var j = 0; j < secondPerm.subclass.length; j++) {
            this.removeByValue(this.MenuDataList, secondPerm.subclass[j].menu);
          }
        }
        // 判断二级权限是否有兄弟选中
        var isSiblingsCheck = false;
        if (firstPerm.subclass != "" && firstPerm.subclass != undefined) {
          for (var i = 0; i < firstPerm.subclass.length; i++) {
            if (this.find(firstPerm.subclass[i].menu)) {
              isSiblingsCheck = true;
              break;
            }
          }
        }
        // 如果没有，就删除一级权限
        if (!isSiblingsCheck) {
          this.removeByValue(this.MenuDataList, firstPerm.menu);
        }
      }
    },
    // 点击三级权限
    thirdPermChanged: function (index, index2, index3) {
      var firstPerm = this.MenuList[index];
      var secondPerm = firstPerm.subclass[index2];
      var thirdPerm = secondPerm.subclass[index3];
      var isThirdCheck = this.find(thirdPerm.menu);
      // 判断三级权限是否被选中
      if (isThirdCheck) {
        // 添加前需要判断是否已存在
        // 添加一级权限
        if (!this.find(firstPerm.menu)) {
          this.MenuDataList.push(firstPerm.menu);
        }
        // 添加二级权限
        if (!this.find(secondPerm.menu)) {
          this.MenuDataList.push(secondPerm.menu);
        }
      } else {
        // 判断三级权限的兄弟是否被选中
        var isSiblingsCheck = false;
        if (secondPerm.subclass != "" && secondPerm.subclass != undefined) {
          for (var i = 0; i < secondPerm.subclass.length; i++) {
            if (this.find(secondPerm.subclass[i].menu)) {
              isSiblingsCheck = true;
              break;
            }
          }
        }
        if (!isSiblingsCheck) {
          // 删除二级权限
          this.removeByValue(this.MenuDataList, secondPerm.menu);
          // 判断二级权限的兄弟是否被选中
          var isThirdSiblingsCheck = false;
          if (firstPerm.subclass != "" && firstPerm.subclass != undefined) {
            for (var i = 0; i < firstPerm.subclass.length; i++) {
              if (this.find(firstPerm.subclass[i].menu)) {
                isThirdSiblingsCheck = true;
                break;
              }
            }
          }
          // 如果没有，删除一级权限
          if (!isThirdSiblingsCheck) {
            this.removeByValue(this.MenuDataList, firstPerm.menu);
          }
        }
      }
    },
    unInsertSend() {
      this.saveLoading = true;
      if (utils.isEmpty(this.roleList.roleName)) {
        utils.messageAlert(this.$t('msg_227'), this.$t('label_358'), this.$t('label_100'))
        this.saveLoading = false;
        return false;
      }
      if (utils.isEmpty(this.MenuDataList)) {
        utils.messageAlert(this.$t('msg_228'), this.$t('label_358'), this.$t('label_100'))
        this.saveLoading = false;
        return false;
      }
      this.roleList.menu = this.MenuDataList;
      Role.insert(this.roleList).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.unInsertVisible = false;
          this.search({
            pageNum: this.pageNum,
            pageSize: this.pageSize
          });
        }
        this.saveLoading = false;
      }).catch((response) => {
        console.log(response)
        this.saveLoading = false;
      })
    },
    unUpdateSend() {
      this.saveLoading = true;
      if (utils.isEmpty(this.roleList.roleName)) {
        utils.messageAlert(this.$t('msg_227'), this.$t('label_358'), this.$t('label_100'))
        this.saveLoading = false;
        return false;
      }
      if (utils.isEmpty(this.MenuDataList)) {
        utils.messageAlert(this.$t('msg_228'), this.$t('label_358'), this.$t('label_100'))
        this.saveLoading = false;
        return false;
      }
      this.roleList.menu = this.MenuDataList;
      Role.update(this.roleList).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.unUpdateVisible = false;
          this.search({
            pageNum: this.pageNum,
            pageSize: this.pageSize
          });
        }
        this.saveLoading = false;
      }).catch((response) => {
        console.log(response)
        this.saveLoading = false;
      })
    },
    del() {
      if (Object.keys(this.tableInfo).length > 0) {
        this.unDeleteVisible = true;
        this.roleList.roleId = this.tableInfo.id;
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    unDeleteSend() {
      Role.del(this.roleList.roleId).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.unDeleteVisible = false;
          this.search({
            pageNum: this.pageNum,
            pageSize: this.pageSize
          });
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    handleClose() {
      this.unDetailList = [];
      this.MenuDataList = [];
      this.unInsertVisible = false;
      this.unUpdateVisible = false;
      this.unDeleteVisible = false;
    },
    searchPage(param) {
      var dataParam = this.searchDataList;
      var newParam = Object.assign(param, dataParam);
      this.pageNum = newParam.pageNum;
      this.pageSize = newParam.pageSize;
      this.$refs['pageModel'].setCurrent(this.pageNum);
      this.selectRoleList(newParam);
    },
    search() {
      let param = {
        pageNum: 1,
        pageSize: this.pageSize
      }
      this.searchPage(param);
    },
    selectRole() {
      Role.selectRole().then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.searchList = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    selectRoleList(param) {
      Role.selectRoleList(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.tableData = data.data.records;
          this.pageCount = data.data.total;
          this.pageSize = data.data.size;
          this.pageNum = data.data.current;
          this.$refs['pageModel'].setCurrent(this.pageNum);

        }
      }).catch((response) => {
        console.log(response)
      })
    },
    handleCurrentChange(info) {
      this.tableInfo = info;
    }
  },
  created() {
    this.search();
    this.selectRole();
  },
  mounted() {
    this.MenuRoleList = this.$store.getters.getMenu;
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/basic/rolePage.vue